


























































































































































































































































































































































































































































































































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
// 高德地图
import VueAMap from 'vue-amap';

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '5744bc0b421f7fcc0e454f8fec352faa',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geolocation'
  ]
  // 默认高德 sdk 版本为 1.4.4
  // v: '1.4.4'
});
import { trim } from '@root/utils/validators';
import Utils from '@root/utils/common';
import OrganizationSearch from '../../../../components/organization-search/index.vue';
import { API_SERVER } from '@root/common/config';
import ImageUploader from '@/components/img-upload/index.vue';
// axios请求
import {
  getRegion,
  getcommunityCode,
  createParkingLot,
  editParkingLot,
  pageList,
  projectList,
  projectInfo,
  getProjectListInfo
} from '@/api/parking-lot-management/index';
// 导入字典
import { typesOperatorsMap, refundMethodMap } from '@/types/parking-lot-management/dictionaries';
import * as _ from 'lodash';
import { isChangcheng, isShiDaill, isShiDaisy, isWenlv, isJinHua } from '@root/utils/env';
// form表单项定义
export interface IForm {
  parkName: string;
  projectName: string;
  organId: string;
  projectCode: string;
  parkType: string;
  deviceProvider: string;
  contacts: string;
  areaId: string;
  address: string;
  businessId: string;
  amapId: string;
  phoneNumber: string;
  pca: any[];
  projectAttribute: string;
  operationType: string;
  refundBankNo: string;
  communityCode: string;
  iotProjectId: string;
  refundMethod: string;
  receiveCompany: string;
  receiveAccount: string;
}
let self: any = {};

@Component({
  components: { OrganizationSearch, ImageUploader }
})
export default class AddEditPark extends Vue {
  @Prop()
  dataForm!: any;

  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  form: any = null;
  validatorsTrim = trim;

  wenlv: boolean = isWenlv;
  isshidaill: boolean = isShiDaill;
  isSDShangYe: boolean = isShiDaisy;
  projectNameOptions: any[] = []; // 项目名称
  isJinHua: boolean = isJinHua;
  images: any[] = [];
  private imagesListData: any[] = [];
  initImageUrls: any[] = []; //原文件列表
  needParkId: boolean = false; //上传文件是否需要传parkId
  fileType: string = '02';
  pageLists: any[] = [];
  //月卡退费方式
  refundMethodOptions: any[] = Utils.toLabelVal(refundMethodMap);
  isChangcheng: boolean = isChangcheng;
  // 车场业态选项
  @Getter('dictionaries/parkType')
  parkTypeMap?: any;
  get parkTypeOptions(): any[] {
    return Utils.toLabelVal(this.parkTypeMap);
  }
  // 边缘服务提供商 01:众畅 02:通通 03:零壹 04:捷顺 05:欧冠 06:科拓 07:蓝卡
  @Getter('dictionaries/parkDeviceProvider')
  parkDeviceProviderMap?: any;
  get edgeServiceProvider(): any[] {
    return Utils.toLabelVal(this.parkDeviceProviderMap);
  }
  // 运营类型 01：开发商委托 02：业委会委托 03：小业主委托
  typesOperators: any[] = Utils.toLabelVal(typesOperatorsMap);
  // 项目属性 01：酬金制 02：包干制
  // detailProperty: any[] = Utils.toLabelVal(detailPropertyMap)
  detailProperty: any[] = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.project_attribute_type || {});

  /**
   * 高德地图相关
   */
  mapCenter = [121.59996, 31.197646];
  longitude: string | number = ''; //经度
  latitude: string | number = ''; //维度
  loaded = false;
  count = 1;
  zoom = 14;
  marker = [];
  plugin = [
    {
      pName: 'Geolocation',
      events: {
        init(o: any) {
          // o 是高德地图定位插件实例
          o.getCurrentPosition((status: any, result: any) => {
            if (result) {
              if (result.position) {
                self.mapCenter = [result.position.lng, result.position.lat];
                self.marker = {
                  position: [result.position.lng, result.position.lat]
                };
              }
              if (result.addressComponent && result.addressComponent.city) {
                self.mapSearchOption.city = result.addressComponent.city;
              }
              self.loaded = true;
              self.$nextTick();
            }
          });
        }
      }
    }
  ];
  mapEvents = {
    click: (e: any) => {
      const { lng, lat } = e.lnglat;
      self.longitude = lng;
      self.latitude = lat;
      self.marker = [e.lnglat.lng, e.lnglat.lat];
      self.mapCenter = [e.lnglat.lng, e.lnglat.lat];
      //@ts-ignore
      if (this.$refs.map.$$getInstance().getZoom() < 14) {
        //@ts-ignore
        this.$refs.map.$$getInstance().setZoom(14);
      }
    }
  };
  // 地图搜索
  mapSearchOption = {
    city: '上海',
    citylimit: true
  };
  // 新希望项目列表
  newHopeProjectList: any[] = [];

  onMapSearchResult(pois: any) {
    let latSum = 0;
    let lngSum = 0;
    if (pois.length > 0) {
      pois.forEach((poi: { lng: number; lat: number }) => {
        const { lng, lat } = poi;
        lngSum += lng;
        latSum += lat;
        // @ts-ignore
        this.marker = [poi.lng, poi.lat];
        this.longitude = lng;
        this.latitude = lat;
      });
      const center = {
        lng: lngSum / pois.length,
        lat: latSum / pois.length
      };
      this.mapCenter = [center.lng, center.lat];
    }
  }

  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }

  @Watch('dataForm', { deep: true })
  dataChanged(val: any) {
    this.init();
    this.longitude = val.longitude;
    this.latitude = val.latitude;
  }

  spining: boolean = false;

  // 生命周期初始化
  async created() {
    self = this;
    this.init();
    this.setRegionList();
    if (this.isshidaill) {
      this.setcommunityCodeList();
      this.getProjectList();
    }
    this.pageListsele();
  }

  async pageListsele() {
    try {
      const res = await pageList({ page: 1, pageSize: 1000 });
      this.pageLists = res.data.map((item: any) => {
        return {
          label: item.iotProjectName,
          value: item.iotProjectId,
          key: item.iotProjectId,
          rootSpaceId: item.rootSpaceId
        };
      });
    } catch (e) {
      console.log(e);
    }
  }

  // 获取项目名称
  async getProjectList() {
    try {
      const res = await projectList();
      this.projectNameOptions = res.data.map((item: any) => {
        return {
          label: item.name,
          value: item.id
        };
      });
    } catch (error) {
      this.$message.error((error && error.msg) || '获取项目名称失败');
    }
  }

  // 获取项目名称
  async getProjectInfo(id: string) {
    try {
      const res = await projectInfo({ projectId: id });
      this.form.setFieldsValue({
        organId: res.data.orgId
      });
    } catch (error) {
      this.$message.error((error && error.msg) || '获取所属机构失败');
    }
  }

  // 获取项目信息
  async getProjectlistofInfo() {
    try {
      const { data } = await getProjectListInfo({
        currPage: 1,
        pageSize: 100000
      });
      console.log(data);
      this.newHopeProjectList = data.datas.map((item: any) => {
        return {
          label: item.projectName,
          value: item.projectCode
        };
      });
    } catch (error) {
      this.$message.error((error && error.msg) || '获取项目列表失败');
    }
  }

  // 改变项目名称
  changeProjectName(id: string) {
    this.form.setFieldsValue({
      projectCode: id
    });
    // this.getProjectInfo(id);
  }

  getOptionName(id, list) {
    let result: any = [];
    if (!id) return {};
    result = _.filter(list, function(o) {
      return o.value == id;
    });
    if (result.length > 0) return result[0];
    return {};
  }
  // 上传图片
  onUploadComplete(fileUrls: any[]) {
    // 新增和删除都会执行一次，在change后触发
    this.images = fileUrls;
  }
  async onFileChange(fileList: any[]) {
    // 图片内容变化即执行，上传过程执行多次
    this.imagesListData = fileList;
  }
  //重置图片
  resetImage() {
    this.$nextTick(() => {
      this.imagesListData = [];
      this.images = [];
      (this.$refs.imgUpload as Vue).resetFileList();
    });
  }
  // 初始化form表单
  init() {
    this.getProjectlistofInfo();
    if (this.isEdit && this.dataForm) {
      if (this.dataForm.images) {
        this.images = this.dataForm.images || [];
      }

      const images = this.images || [];
      if (images) {
        this.imagesListData = images.map((item: string, index: number) => {
          return {
            uid: index,
            name: item,
            status: 'done',
            url: `${API_SERVER.imgBaseUrl}${item}`,
            filePath: item
          };
        });
        this.initImageUrls = JSON.parse(JSON.stringify(images));
        this.$nextTick(() => {
          (this.$refs.imgUpload as any).initList();
        });
      }
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const {
            parkName,
            projectName,
            organId,
            projectCode,
            parkType,
            deviceProvider,
            contacts,
            areaId,
            address,
            businessId,
            amapId,
            phoneNumber,
            pca,
            projectAttribute,
            operationType,
            refundBankNo,
            refundMethod,
            communityCode,
            iotProjectId,
            receiveCompany,
            receiveAccount
          } = this.dataForm;
          return {
            iotProjectId: this.$form.createFormField({
              value: iotProjectId
            }),
            communityCode: this.$form.createFormField({
              value: communityCode
            }),
            refundBankNo: this.$form.createFormField({
              value: refundBankNo
            }),
            refundMethod: this.$form.createFormField({
              value: refundMethod
            }),
            operationType: this.$form.createFormField({
              value: operationType
            }),
            projectAttribute: this.$form.createFormField({
              value: projectAttribute
            }),
            pca: this.$form.createFormField({
              value: pca
            }),
            parkName: this.$form.createFormField({
              value: parkName
            }),
            projectName: this.$form.createFormField({
              value: projectName
            }),
            organId: this.$form.createFormField({
              value: organId
            }),
            projectCode: this.$form.createFormField({
              value: projectCode
            }),
            parkType: this.$form.createFormField({
              value: parkType
            }),
            deviceProvider: this.$form.createFormField({
              value: deviceProvider
            }),
            contacts: this.$form.createFormField({
              value: contacts
            }),
            areaId: this.$form.createFormField({
              value: areaId
            }),
            address: this.$form.createFormField({
              value: address
            }),
            businessId: this.$form.createFormField({
              value: businessId
            }),
            amapId: this.$form.createFormField({
              value: amapId
            }),
            phoneNumber: this.$form.createFormField({
              value: phoneNumber
            }),
            receiveAccount: this.$form.createFormField({
              value: receiveAccount
            }),
            receiveCompany: this.$form.createFormField({
              value: receiveCompany
            })
          };
        }
      });
    } else {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            parkType: this.$form.createFormField({
              value: this.parkTypeOptions[0] ? this.parkTypeOptions[0].value || '' : ''
            }),
            deviceProvider: this.$form.createFormField({
              value: this.edgeServiceProvider[0] ? this.edgeServiceProvider[0].value || '' : ''
            }),
            projectAttribute: this.$form.createFormField({
              value: this.detailProperty[0] ? this.detailProperty[0].value || '' : ''
            }),
            operationType: this.$form.createFormField({
              value: this.typesOperators[0] ? this.typesOperators[0].value || '' : ''
            }),
            refundMethod: this.$form.createFormField({
              value: this.refundMethodOptions[0] ? this.refundMethodOptions[0].value || '' : ''
            })
          };
        }
      });
    }
  }

  getRegionList = [];
  // 获取省市区
  async setRegionList() {
    try {
      const { status, msg, code, data } = await getRegion({ userId: '11' });
      if (status === '9999') {
        this.getRegionList = data;
      }
    } catch (e) {
      console.log(e);
    }
  }
  getCommunityCodeList: any[];
  // 获取社区代码
  async setcommunityCodeList() {
    try {
      const result = await getcommunityCode();
      const list = [result.data];
      this.getCommunityCodeList = this.getTreeData(list);
    } catch (e) {
      console.log(e);
    }
  }
  getTreeData(data) {
    for (var i = 0; i < data.length; i++) {
      if (data[i].sonAccountList) {
        data[i].children = data[i].sonAccountList;
        this.getTreeData(data[i].children);
      }
      data[i].value = data[i].id;
      data[i].label = data[i].name;
    }
    return data;
  }
  // 提交监听处理
  async handleSubmit(e: any) {
    e.stopPropagation();
    e.preventDefault();
    let code = this.form.getFieldValue('projectCode');
    this.newHopeProjectList.forEach(item => {
      if (item.value === code) {
        console.log(item);
        this.form.setFieldsValue({
          projectName: item.label
        });
      }
    });
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!this.longitude || !this.latitude) {
        this.$message.error('请在地图上获取车场经纬度');
        return false;
      }
      let str: any = {};
      if (values.iotProjectId) {
        str = this.getOptionName(values.iotProjectId, this.pageLists);
      }
      const strList: Record<string, any> = {
        iotProjectId: str.value || '',
        iotProjectName: str.label || '',
        rootSpaceId: str.rootSpaceId || ''
      };
      if (!err) {
        if (this.spining) return;
        this.spining = true;
        const requesParam: any = {
          ...values,
          provinceId: values.pca[0],
          cityId: values.pca[1],
          areaId: values.pca[2],
          longitude: this.longitude,
          latitude: this.latitude,
          image: this.images.join(','),
          operationType: values.operationType || '',
          projectAttribute: values.projectAttribute || '',
          iotProjectId: values.iotProjectId || '',
          ...strList
        };
        if (this.isshidaill) {
          requesParam.communityCode = requesParam.communityCode.join(',');
        }
        if (this.isEdit) {
          requesParam.parkId = this.dataForm.parkId;
          this.onEdit(requesParam);
        } else {
          this.onAdd(requesParam);
        }
      } else {
        console.log(err);
      }
    });
  }
  // 添加车场
  async onAdd(values: IForm) {
    try {
      const { status, code, msg, data } = await createParkingLot(values);
      if (status === '9999') {
        this.$message.success('新增成功');
        this.$emit('ok', { ...values, parkId: data });
        this.form.resetFields();
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '新增失败');
    } finally {
      this.spining = false;
    }
  }
  // 编辑车场
  async onEdit(values: IForm) {
    try {
      const res = await editParkingLot(values);
      this.$message.success('编辑成功');
      this.$emit('ok', { ...values, parkId: this.dataForm.parkId });
      this.form.resetFields();
    } catch (e) {
      this.$message.error((e && e.msg) || '编辑失败');
    } finally {
      this.spining = false;
    }
  }
}
